import React, { useState } from 'react';
import '../css/CancelEvent.css'; // Import the CSS file

function CancelEvent() {
  const [ticket, setTicket] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setTicket(e.target.value);
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_BASE_URL}/api/cancel-event`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ticket }),
      });

      const data = await response.json();
      if (data.status === 200) {
        setFormSubmitted(true);
        setSuccessMessage(data.message);
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cancel-event-container">
      <div className="logo-container">
        <img src={`${process.env.REACT_APP_ASSETS_URL}/logo.png`} alt="Logo" className="logo" />
      </div>
      <h2>Cancellazione Evento</h2>
      {!formSubmitted ? (
        <div className="form-container">
          <p>Puoi cancellare la tua prenotazione entro 72 ore dalla data dell'evento e convertire il tuo biglietto in una Gift Card valida per 2 mesi.</p>
          <p>Il codice della giftcard rimarrà lo stesso del tuo biglietto originale, puoi quindi utilizzarlo per prenotare un altro evento.</p>
          <form className="form" onSubmit={(e) => e.preventDefault()}>
            <label className="label" htmlFor="ticket">Codice Biglietto:</label>
            <input className="input" type="text" name="ticket" value={ticket} onChange={handleChange} required />
            {loading ? (
              <div className="spinner-container">
                <div className="spinner"></div>
              </div>
            ) : (
              <button className="button" type="button" onClick={handleSubmit} disabled={loading}>
                Converti in Gift Card
              </button>
            )}
          </form>
        </div>
      ) : (
        <div className="success-container">
          <p>{successMessage}</p>
          <button className="button" onClick={() => window.location.href=`${process.env.REACT_APP_WEBSITE_BASE_URL}/eventi`}>Prenota un Evento</button>
        </div>
      )}
    </div>
  );
}

// Add spinner styles
const spinnerStyles = `
.spinner {
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 2px solid #3498db;
  width: 12px;
  height: 12px;
  animation: spin 1s linear infinite;
}
`;

// Add keyframes for the spinner animation
const spinnerKeyframes = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;

// Add spinner container styles
const spinnerContainerStyles = `
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px; // Adjust height as needed
}
`;

// Inject spinner styles into the document
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(spinnerStyles, styleSheet.cssRules.length);
styleSheet.insertRule(spinnerKeyframes, styleSheet.cssRules.length);
styleSheet.insertRule(spinnerContainerStyles, styleSheet.cssRules.length);

export default CancelEvent; 